import React from 'react';
import './Contact.css';
import SectionHeader from '../SectionHeader/SectionHeader';

const Contact = () => {
  return (
    <div className="Contact__container">
      <SectionHeader title="Contact" />
    </div>
  );
};

export default Contact;
